import { FC } from "react"
import { IOzonOrder } from "../../../app/reducers/ordersReducer"
import { FormKatrenOrder } from "../FormKatrenOrder"
import { getOzonOrdersForKatren } from "./utils"

type FormOzonKatrenOrder = {
  orders?: IOzonOrder[]
  isDisabled?: boolean
}
export const FormOzonKatrenOrder: FC<FormOzonKatrenOrder> = ({
  orders,
  isDisabled,
}) => {
  return (
    <FormKatrenOrder
      isDisabled={isDisabled || !orders?.length}
      getOrdersForKatren={() => getOzonOrdersForKatren(orders || [])}
    />
  )
}
